import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	private showToastState: WritableSignal<boolean> = signal<boolean>(false);
	private autoHideAfterState: WritableSignal<number> = signal(3000);
	private typeState: WritableSignal<string> = signal<string>('success');
	private messageState: WritableSignal<string> = signal<string>('');

	private timeOut: ReturnType<typeof setTimeout> | undefined;

	get showToast(): Signal<boolean> {
		return this.showToastState;
	}

	get type(): Signal<string> {
		return this.typeState;
	}

	get message(): Signal<string> {
		return this.messageState;
	}

	public show(message: string, type = 'success'): void {
		this.typeState.set(type);
		this.messageState.set(message);
		this.showToastState.set(true);
		this.autoHideToast(this.autoHideAfterState());
	}

	public hide(): void {
		if (this.timeOut) {
			clearTimeout(this.timeOut);
		}
		this.showToastState.set(false);
	}

	private autoHideToast(delay: number): void {
		this.timeOut = setTimeout(() => {
			this.hide();
		}, delay);
	}
}
